import React from 'react';
import { capitalize, isNull } from 'lodash';
import moment from 'moment-timezone';

import { FontAwesomeIcon, SparkleIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';
import { titleize } from 'utilities/formatting';

import ContextualLink from '@test_prep/app/components/contextual_link';

import style from './style.module.scss';

interface Props {
  createdAt: number;
  id: number;
  question: {
    title: string;
  };
  score: number;
  status: string;
}

export default (props: Props) => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles';

  const status = () => {
    if (props.status === 'finished') {
      return 'Graded';
    } else if (props.status === 'error') {
      return 'Error';
    } else if (props.status === 'pending_answers') {
      return 'Waiting for all questions to be answered';
    } else {
      return 'Grading';
    }
  };

  return (
    <ContextualLink
      className={style.scoreReportLink}
      href={paths.scoreReport(props.id)}
    >
      <div className="align-items-center d-flex gap-m">
        <div style={{ position: 'relative', zIndex: 1 }}>
          <div
            className={style.gradientOutline}
            style={{ borderRadius: '100%', height: 40, width: 40 }}
          >
            <div
              className="align-items-center d-flex gap-xs text-bold"
              style={{
                background: 'linear-gradient(90deg, #0577E9, #5227F8)',
                left: '50%',
                position: 'absolute',
                top: '50%',
                transform: 'translateX(-50%) translateY(-50%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              {
                props.status !== 'finished' && isNull(props.score) ? (
                  <FontAwesomeIcon icon="refresh" style={{ fontSize: 14 }} />
                ) : (
                  <h4 className="u-margin-A-n">{isNull(props.score) ? 'NS' : props.score}</h4>
                )
              }
            </div>
          </div>
        </div>

        <div className="align-items-lg-center d-flex flex-1 flex-column flex-lg-row gap-m">
          <div className="d-flex flex-column flex-1 gap-xxs">
            <div>{props.question.title}</div>
            <div className="small text-gray-light">
              {capitalize(moment(props.createdAt * 1000).tz(timeZone).fromNow())} - {status()}
            </div>
          </div>

          <div className="d-flex">
            <div style={{ position: 'relative', zIndex: 1 }}>
              <div className={style.gradientOutline} style={{ borderRadius: 24, padding: '4px 16px' }}>
                <div
                  className="align-items-center d-flex gap-xs text-bold"
                  style={{
                    background: 'linear-gradient(90deg, #0577E9, #5227F8)',
                    fontSize: 14,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent'
                  }}
                >
                  <SparkleIcon color="#0577E9" size={14} />
                  View
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ContextualLink>
  );
};
